import React from 'react';
import {
    Card,
    Typography,
    Button,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from '@material-ui/core';
import { Add, Close, Delete } from '@material-ui/icons';

const QuotePageEquipmentList = ({
    equipment,
    onAddItem,
    onRemoveEquipment,
    onRemoveItem,
    userRole = 'tecnico',
    classes = {},
    currentLanguage
}) => {

    const formatCurrency = (valor) => {
        return new Intl.NumberFormat(currentLanguage.lang_code === 'en' ? 'en-US' : 'pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };

    if (!equipment || equipment.length === 0) {
        return (
            <Typography color="textSecondary" style={{ textAlign: 'center', padding: 20 }}>
                {currentLanguage.bepiService.workshop.workshop_quote_form_no_equip_msg}
            </Typography>
        );
    }

    return equipment.map(equip => (
        <Card key={equip.id} className={classes.equipamentoCard}
            style={{ backgroundColor: userRole === 'admin' ? '#deeeff' : '#eeffee', marginBottom: 16, padding: 16, position: 'relative' }}>

            <IconButton
                style={{ position: 'absolute', top: 8, right: 8 }}
                onClick={() => onRemoveEquipment(equip.id)}
            >
                <Close />
            </IconButton>

            <Typography variant="h6" gutterBottom>
                {equip.nome}
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
                ID: {equip.id} | Marca: {equip.marca || "---"} | Modelo: {equip.modelo || "---"} | Série: {equip.serie || "---"}
            </Typography>

            <Button
                variant="outlined"
                color="primary"
                size="small"
                startIcon={<Add />}
                onClick={() => onAddItem(equip.id, equip.servico_id)}
            >
                {currentLanguage.bepiService.workshop.workshop_quote_form_add_item_btn}
            </Button>

            {renderEquipmentItems(equip, onRemoveItem, userRole, formatCurrency, currentLanguage)}
        </Card>
    ));
};

const renderEquipmentItems = (equipment, onRemoveItem, userRole, formatCurrency, currentLanguage) => {
    if (!equipment.itens || equipment.itens.length === 0) return null;

    return (
        <Paper style={{ marginTop: 16, overflow: 'auto' }}>
            <Table size="small">
                <TableHead>
                    <TableRow style={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                        <TableCell>{currentLanguage.bepiService.workshop.workshop_quotations_table_type}</TableCell>
                        <TableCell>{currentLanguage.bepiService.workshop.workshop_quote_form_table_qty}</TableCell>
                        <TableCell>{currentLanguage.bepiService.workshop.workshop_quote_form_table_item}</TableCell>
                        {userRole === 'admin' && <TableCell>{currentLanguage.bepiService.workshop.workshop_quotations_table_value}</TableCell>}
                        <TableCell>{currentLanguage.bepiService.shared.shared_clients_table_actions}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {equipment.itens.map((item, index) => (
                        <TableRow key={index}>
                            <TableCell>{item.tipo === 'peca' ? currentLanguage.bepiService.workshop.workshop_quote_item_type_part : currentLanguage.bepiService.workshop.workshop_quote_item_type_service}</TableCell>
                            <TableCell>{item.qtd}</TableCell>
                            <TableCell>
                                {item.codigo} - {item.nome}
                                {item.obs && (
                                    <Typography variant="caption" display="block" color="textSecondary">
                                        ({item.obs})
                                    </Typography>
                                )}
                            </TableCell>
                            {userRole === 'admin' && (
                                <TableCell>{formatCurrency(item.preco)}</TableCell>
                            )}
                            <TableCell>
                                <IconButton
                                    size="small"
                                    onClick={() => onRemoveItem(equipment.id, index)}
                                >
                                    <Delete />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    );
};

export default QuotePageEquipmentList;
